import { HomeScreen } from '@strata/react-page-templates';

import { AppRoutes } from 'services/routes';
import { useGetHomeScreenMessagesQuery } from 'store/api/announcementApi';

export const Home = () => {
    const { data: messages } = useGetHomeScreenMessagesQuery();

    return (
        <HomeScreen
            illustration={HomeScreen.Illustration.HEART}
            button={{ label: 'Enter Referral', path: AppRoutes.referralForm }}
            welcomeMessagePartOne="With Real Time Auth (RTA), you can obtain specialty drug authorizations quickly. Dynamically aligned to health plan drug policies, RTA streamlines the prior authorization and referral process to get your patients started on therapy sooner."
            messages={messages}
            viewAllUpdatesUrl={AppRoutes.updatesHistory}
        />
    );
};
